var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tv tv-list tv-list-ruled",attrs:{"role":"list","data-turbolinks":"false"}},_vm._l((_vm.sortedAndFilteredWalls),function(wall){return _c('padlet-listitem',{key:wall.id,attrs:{"wall":wall,"role":"listitem","actions":_vm.actions},nativeOn:{"click":function($event){return _vm.onClick($event, wall)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }